import * as z from "zod";

export const getGoogleMerchantCenterIntegration = {
  name: "getGoogleMerchantCenterIntegration" as const,
  input: z.null(),
  output: z.object({
    connected: z.boolean(),
    merchantId: z.string().nullable(),
    ucpEnabled: z.boolean(),
  }),
};
